import '@/styles/main.scss';

import Vue from 'vue';
Vue.config.productionTip = false;

import { setOptions, VueSvgIcon } from '@yzfe/vue-svgicon';
// import '@yzfe/svgicon/lib/svgicon.css'; // solved by custom css
setOptions({
    defaultWidth: 24,
    defaultHeight: 24,
    classPrefix: 'w-svgicon',
});
Vue.component('icon', VueSvgIcon);

import VueSelect from 'vue-select';
Vue.component('VueSelect', VueSelect);

import App from './App.vue';
import store from '@/store';

store.state.api = 'api/';
store.state.initialized = false;
store.dispatch('gotoPage'); // begin at page 1

new Vue({
    store,
    render: (h) => h(App),
}).$mount('#ludovico');
